module.exports = __webpack_public_path__ + "static/media/country_ve.cd53770f.webp";